import { TagsMenuItem } from '../../../types';

/*
  This util sorts tags in an order of increasing dependency using a BFS traversal
  for a graph where every tag is a node and it's edges are defined by tags that it
  conditionally affects
*/
interface GraphNode {
  controls: string[];
  tag: TagsMenuItem;
}

const createGraph = (tagsData: TagsMenuItem[]): Record<string, GraphNode> => {
  const graph: Record<string, GraphNode> = {};
  tagsData.forEach((tag) => {
    graph[tag.id] = { controls: [], tag: tag };
  });

  tagsData.forEach((tag) => {
    if (tag.settings && tag.settings.controlConfig && tag.settings.controlConfig.controls) {
      tag.settings.controlConfig.controls.forEach((control) => {
        const controllingEntityId = control.controllingEntity.value;
        if (graph[controllingEntityId]) {
          graph[controllingEntityId].controls.push(tag.id); // unidirectional edge
        }
      });
    }
  });
  return graph;
};

const bfsTraversal = (tagsData: TagsMenuItem[]): TagsMenuItem[] => {
  const graph = createGraph(tagsData);
  const result: TagsMenuItem[] = [];
  const visited = new Set<string>();

  const findRoots = (): string[] => {
    const allNodes = new Set<string>();
    const dependentNodes = new Set<string>();

    for (const nodeId in graph) {
      allNodes.add(nodeId);
      graph[nodeId].controls.forEach((controlId) => dependentNodes.add(controlId));
    }

    const rootNodes = Array.from(allNodes).filter((nodeId) => !dependentNodes.has(nodeId));
    return rootNodes;
  };

  const bfs = (startNodeId: string) => {
    const queue: string[] = [startNodeId];
    visited.add(startNodeId);

    while (queue.length > 0) {
      const nodeId = queue.shift()!;
      result.push(graph[nodeId].tag);

      graph[nodeId].controls.forEach((controlId) => {
        if (!visited.has(controlId)) {
          visited.add(controlId);
          queue.push(controlId);
        }
      });
    }
  };

  // bfs from each root
  const rootNodes = findRoots();
  rootNodes.forEach((rootNode) => bfs(rootNode));

  return result;
};

export { bfsTraversal };
